import math from 'mathjs';
import { AnswerFormulaMap, DynamicQuestionVariable, formatScientificNotation, toScientificNotation, VariableMap, VariableTypes } from './types';
import {QListCountArray} from '../component/vectors/canvas'


function replaceAll(string, token, newtoken) {
    if(token!==newtoken)
    while(string.indexOf(token) > -1) {
        string = string.replace(token, newtoken);
    }
    return string;
}
function gcd(a, b) {
    if (b < 0.0000001) return a;                // Since there is a limited precision we need to limit the value.
  
    return gcd(b, Math.floor(a % b));           // Discard any fractions due to limitations in precision.
  };
function decimalToFraction(fraction){
    
 
      fraction = fraction.toFixed(2);
      //console.log('fraction',fraction);
      var len = fraction.toString().length - 2;
      
      var denominator = Math.pow(10, len);
      var numerator = fraction * denominator;
      
      var divisor = gcd(numerator, denominator);    
      
      numerator /= divisor;                         
      denominator /= divisor;                       
      if(denominator === 1){
        return Math.floor(numerator);
      }
      
        
        
     return  Math.floor(numerator) + '/' + Math.floor(denominator);
}


function toSigFig(x, n) {
    /**
     * https://github.com/corriander/python-sigfig/blob/dev/sigfig/sigfig.py
     * Convert a float, x, to a string with n significant figures.
     * This function returns a decimal string representation of a float
     * to a specified number of significant figures.
     * 
     * @example
     * string(9.80665, 3) // returns '9.81'
     * string(0.0120076, 3) // returns '0.0120'
     * string(100000, 5) // returns '100000'
     * 
     * Note: The last representation is, without context, ambiguous. This
     * is a good reason to use scientific notation, but it's not always
     * appropriate.
     * 
     * Note: Performing this operation as a set of string operations arguably
     * makes more sense than a mathematical operation conceptually. It's
     * the presentation of the number that is being changed here, not the
     * number itself (which is in turn only approximated by a float).
     */
    
    n = parseInt(n);
    x = parseFloat(x);
    
    if (n < 1) throw new Error("1+ significant digits required.");
    
    // retrieve the significand and exponent from the S.N. form
    // Using toExponential to get scientific notation with n-1 decimal places
    const parts = x.toExponential(n - 1).split('e');
    let s = parts[0];
    let e = parseInt(parts[1]);
    
    if (e === 0) {
        // Significand requires no adjustment
        return s;
    }
    
    s = s.replace('.', '');
    
    if (e < 0) {
        // Placeholder zeros need creating
        return `0.${'0'.repeat(Math.abs(e) - 1)}${s}`;
    } else {
        // Decimal place needs shifting
        s += '0'.repeat(Math.max(0, e - n + 1)); // s now has correct s.f.
        let i = e + 1;
        let sep = '';
        if (i < n) sep = '.';
        if (s[0] === '-') i += 1;
        return s.slice(0, i) + (s.slice(i) ? sep + s.slice(i) : '');
    }
}
  
function formatResult(variable,options){
    if(variable && options){
        let formattedValue = variable;
        if(options.type){
            switch(options.type){
                case VariableTypes.INT:                  
                    formattedValue = Math.round(variable);
                break;
                case VariableTypes.FLOAT:
                    if(options.sigFig){
                        ////console.log('options.decimalLimit',options.decimalLimit);
                        
                        // formattedValue = MathParserUtil.ToPlainString(variable.toPrecision(parseInt(options.sigFig,10)));
                        formattedValue = toSigFig(variable, parseInt(options.sigFig,10));
                        // console.debug("formattedValue and formattedValue2>>>", formattedValue, formattedValue2)
                    }
                    
                break;
                case VariableTypes.FRACTION:
                    formattedValue =   decimalToFraction(variable);
                break;
                case VariableTypes.SCIENTIFIC_NOTATION:
                    console.log('variable.toString()',variable.toString());
                    
                    //formattedValue = formatScientificNotation(variable.toString(),{requiredWholeNumber:parseInt(options.decimalLimit,10),precision:parseInt(options.precision,10)});
                    
                    formattedValue = toScientificNotation(variable, parseInt(options.decimalLimit));

                break;
                default:
                break;
            }


            return formattedValue;
        }

    }

    return variable;
    
}

/*

1) Parse Question and Detech the Variables in it
2) Show UI to set properties for each variable.
3) A ball travel [x] meters at a speed of [v] m/s. How long was the time of travel? 
*/
export default class MathParserUtil{
    
    static getFractionValue(num){
        return math.fraction(num)
    }

    static removeBrackets = (text) => {
        return text.replace("{{","").replace("}}","");
    }
    static getFormulaFromText = (strQuestionText,strict) => {
        let matchedStringArr =  strQuestionText.match(/{{(.*?)}}/g);
        if(matchedStringArr && matchedStringArr.length > 0){
            let matchedStr = matchedStringArr[0];
            matchedStr = matchedStr.replace("{{","");
            matchedStr = matchedStr.replace("}}","");
            return matchedStr;
        }
        //if strict === true then only return valid formula else return null
        if(strict === true){
            return null;
        }
        return strQuestionText;
    }

    static shouldRandomize = (answerArr) => {
        if(answerArr.length > 1){
            let AnswerCountArr = QListCountArray(answerArr)
            let isSameAnswersPresent = AnswerCountArr.some((c)=> c>1) 
            return isSameAnswersPresent ? true:false;
        }else{
            return false;
        }
    }

    static checkAnswerFormula = (answerArr) => {
        for(let x=0;x<answerArr.length;x++){
            let prevIndex = answerArr.indexOf(answerArr[x], x+1)
            if(prevIndex){
                return `The answer formula for Answer-${prevIndex+1} is identical to Answer-${x+1}. Please make sure to have a unique formula for each answer.`;
            }
        }
    }
    
    static computeFormula = (strQuestionText,variablesMap,displayOptions)=> {
        
        try{

        let formulaStringArray = MathParserUtil.getAnswerFormulasArrayFromText(strQuestionText);
        
        if(formulaStringArray && formulaStringArray.length > 0){
            formulaStringArray.forEach(formulaString => {
                let formulaWithValues =  MathParserUtil.setVariablesToText(formulaString,variablesMap); 
                console.debug("formulaWithValues>>>??", formulaWithValues)
                strQuestionText = strQuestionText.replace(formulaString,formatResult(math.eval(formulaWithValues.replace("{{","").replace("}}","")),displayOptions))
            });
        }

        }catch(e){
            console.error(e);
        }
        strQuestionText = strQuestionText.replace(/\^(-?\d+)\s*/g, '^{$1}'); // this is added to take all integers after ^ upto empty space
        console.debug("strQuestionText===>>", strQuestionText)
        return strQuestionText;
    }
    static computeAnswer = (strQuestionText, variablesMap) => {
        let formulaString = MathParserUtil.getFormulaFromText(strQuestionText);
        if (formulaString && formulaString.length > 0) {
            let formulaWithValues = MathParserUtil.setVariablesToText(formulaString, variablesMap);
    
            try {
                let correctAnswer = math.eval(formulaWithValues);
                return correctAnswer;
            } catch (error) {
                console.error('Math evaluation error:', error);
                return "";
            }
        }
        return null;
    }

    static getVariablesFromText = (strQuestionText,variablesMap) => {
        //
        if(variablesMap === undefined || variablesMap === null){
            variablesMap = MathParserUtil.createMap();
        }
        
        
        let variableArray = strQuestionText.match(/\[(.*?)\]/g);
        
        if(variableArray && variableArray.length > 0){
            variableArray.forEach(variable => {
                if(!variablesMap.has(variable)){
                    let variableObj = new DynamicQuestionVariable();
                    variableObj.name = variable;
                    variablesMap.set(variable,variableObj);
                }
                
            });

            
            for (var key of variablesMap.keys()) {
                if(!variableArray.includes(key))
                    variablesMap.delete(key);
            }

            return variablesMap;
        }
        
        
    }
    static createVariablesMapfromAnswerVariable = (variableArray) => {

        let variablesMap = MathParserUtil.createMap();

        if(variableArray && variableArray.length > 0){
            variableArray.forEach(variable => {
                if(!variablesMap.has(variable)){
                    let variableObj = new DynamicQuestionVariable();
                    variablesMap.set(variable.name,variableObj);
                }
                
            });

            
            for (var key of variablesMap.keys()) {
                if(!variableArray.includes(key))
                    variablesMap.delete(key);
            }

            return variablesMap;
        }

        return variablesMap
        
        
    }

    static buildQuestionVariablesMap(variablesArray){
        let variablesMap  =  MathParserUtil.createMap();
        if(variablesArray){
            variablesArray.forEach(variable => {
                variablesMap.set(variable.name,variable);
         });
        }
      
        return variablesMap;
      }

    //Creates a Map and Adds custom helper functions before returing
    static createMap(){
        return new VariableMap();
    }

    static setVariablesToText = (strQuestionText,variablesMap,options) => {
        let localStrQuestionText = strQuestionText;
       
        
        if(variablesMap === undefined || variablesMap === null){
            //console.log('undefined');
            
           return strQuestionText;
        }

        
        for (var key of variablesMap.keys()) {
            if(options){
                if(options.formatValues === true){
                    localStrQuestionText = replaceAll(localStrQuestionText,key,variablesMap.get(key).formattedValue);
                }

                localStrQuestionText = replaceAll(localStrQuestionText,key,variablesMap.get(key).value);
            }else{
                if (key.includes("\\vec")) {

                    for (var key of variablesMap.keys()) {
                        localStrQuestionText = replaceAll(localStrQuestionText, `${key}_x`, variablesMap.get(key).x);
                        localStrQuestionText = replaceAll(localStrQuestionText, `${key}_y`, variablesMap.get(key).y);
                        localStrQuestionText = replaceAll(localStrQuestionText, `${key}_ang`, variablesMap.get(key).angle);
                        localStrQuestionText = replaceAll(localStrQuestionText, `${key}_mag`, variablesMap.get(key).mag);
                    }

                    localStrQuestionText = localStrQuestionText.replaceAll("[", "").replaceAll("]", "");
                    // console.debug("localStrQuestionText>>>>", localStrQuestionText)


                   /*  let neKey = "[" + key + "]"
                    let obj = variablesMap.get(key)
                    let value = 0;
                    if (obj) {
                        value = obj.x;
                        let textX = key+"_x";
                        let textY = key+"_y";
                        console.debug("textX and textY", textX, textY, key, strQuestionText, strQuestionText.includes(textX), strQuestionText.includes(textY))
                        if (strQuestionText.includes(textX)) {
                            value = obj.x ? obj.x : 0;
                        } 
                        
                        if (strQuestionText.includes(textY)) {
                            value = obj.y ? obj.y : 0;
                        }
                    }
                    // console.debug("objobj", key, obj, value)
                    
                    // TODO: Need to evaludate x and y from strQuestionText
                    localStrQuestionText = localStrQuestionText.replaceAll("_x", "")
                    localStrQuestionText = localStrQuestionText.replaceAll("_y", "");
                    // console.debug("localStrQuestionText>>>>", localStrQuestionText, key, value)

                    localStrQuestionText = replaceAll(localStrQuestionText,neKey,value); */
                } else {

                    localStrQuestionText = replaceAll(localStrQuestionText,key,variablesMap.get(key).value);
                }
                
            }
            console.debug("localStrQuestionText>>>>", localStrQuestionText, key)
            
            
        }
        
        return localStrQuestionText;
    }

    static isIllegalNumber = (val) =>{
      
        if(val === undefined || val === null){
            return true;
        }
        if((val.trim && val.trim() === "") || isNaN(val))
          return true;
  
          return false;
      }
  
      
    static ToPlainString = (num) => {
        return (''+num).replace(/(-?)(\d*)\.?(\d+)e([+-]\d+)/,
        function(a,b,c,d,e) {
            return e < 0
            ? b + '0.' + Array(1-e-c.length).join(0) + c + d
            : b + c + d + Array(e-d.length+1).join(0);
        });
    }

    static getAnswerFormulasFromText = (strAnswerText,oldMap) => {
        var newMap = new AnswerFormulaMap();
        let answerFormulaArray = strAnswerText.match(/\{{(.*?)\}}/g);
        if(answerFormulaArray && answerFormulaArray.length > 0){
            answerFormulaArray.forEach(formulaTextU=>{
                const formulaText= formulaTextU.trim();
                if(oldMap){
                    const oldFormulaObj = oldMap.get(formulaText);
                    if(oldFormulaObj){
                        newMap.set(formulaText,{...oldFormulaObj});
                    }else{
                        newMap.set(formulaText,{text:formulaText})
                    }
                }else{
                    newMap.set(formulaText,{text:formulaText})
                }
                
                
            });
        }

        return newMap;
    }

    static getAnswerFormulasArrayFromText = (strAnswerText) => {
        return strAnswerText.match(/\{{(.*?)\}}/g);
    }
    
    static buildAnswerFormulasMap(answersFormulaArray){
        let variablesMap  = new AnswerFormulaMap();
        if(answersFormulaArray && answersFormulaArray.length > 0){
            console.log("answersFormulaArray",answersFormulaArray);
            
            answersFormulaArray.forEach(variable => {
                variablesMap.set(variable.text.trim(),variable);
         });
        }
      
        return variablesMap;
    }

    static splitAnswerTextFormulaToArray(strAnswerText){
        if(strAnswerText && strAnswerText.length > 0){
            return strAnswerText.split(/\{{(.*?)\}}/g);
        }

        return [strAnswerText];
    }
}